import React from 'react';

interface BlockWrapperProps {
  children?: React.ReactNode;
  mode?: Mode;
  className?: string;
}

type Mode = 'box';

export const BlockWrapper = ({
  children,
  className,
  mode = 'box',
}: BlockWrapperProps) => {
  const createWrapper = (mode: Mode) => {
    switch (mode) {
      case 'box':
        return (
          <div
            className={`richTextSection relative rounded-b-card-mobile bg-background-primary-light pb-11 text-text-default lg:rounded-card lg:pt-12 lg:p-20 xl:p-24 ${
              className ? className : ''
            }`}
          >
            {children}
          </div>
        );
      default:
        break;
    }
  };
  return <>{createWrapper(mode)}</>;
};
